import { IKey } from '@/common/constants/ikey'

/** Поля PUSH/app-event, которые не должны попадать в platform currentData (reload/panel, action, …). */
const SERVER_EVENT_EXACT_KEYS = new Set([
  '_listener',
  '_event',
  '_sessionId',
  '_action',
])

/** Служебные поля web-клиента, не отправляемые на middleware. */
const PLATFORM_REQUEST_EPHEMERAL_KEYS = new Set([
  '__VERIFIED',
  IKey.JS_WEB_RESPONSE,
  IKey.JS_WEB_EXCEPTION,
  IKey.JS_PROGRESS_BAR_RESPONSE,
  IKey.JS_MESSAGES_RESPONSE,
])

const SERVER_EVENT_KEY_PREFIXES = ['_param.', '_user.', '_owner.'] as const

export function isServerEventOverlayFieldKey(key: string): boolean {
  const normalized = String(key ?? '').trim()
  if (!normalized) return false
  if (SERVER_EVENT_EXACT_KEYS.has(normalized)) return true
  return SERVER_EVENT_KEY_PREFIXES.some((prefix) => normalized.startsWith(prefix))
}

/** Убирает ephemeral overlay из en._serialize() / merged reload payload. */
export function isPlatformRequestEphemeralFieldKey(key: string): boolean {
  const normalized = String(key ?? '').trim()
  if (!normalized) return false
  return PLATFORM_REQUEST_EPHEMERAL_KEYS.has(normalized)
}

export function stripServerEventOverlayFields(
  fields: Record<string, unknown> | null | undefined,
): Record<string, unknown> {
  if (!fields || typeof fields !== 'object' || Array.isArray(fields)) {
    return {}
  }
  const out: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(fields)) {
    if (!isServerEventOverlayFieldKey(key) && !isPlatformRequestEphemeralFieldKey(key)) {
      out[key] = value
    }
  }
  return out
}
